/* nebe-ship-bar.js — lišta v hlavičce. Expediční řádek počítá sdílený nebe-ship.js,
 * tenhle soubor řeší jen text, zavírání a doladění výšky.
 *
 * ŠTAFETA DVOU ŘÁDKŮ. Lišta má promo řádek nahoře a expediční slib dole a podle denní doby
 * si předávají, kdo z nich tiká — tikat smí vždycky jen jeden, jinak se pruh čte jako
 * výherní automat:
 *   00:00–09:00 prac. den  horní statický, dolní „objednej do 14:00…"
 *   09:00–14:00 prac. den  horní statický, dolní tiká po vteřinách do uzávěrky
 *   po 14:00 / víkend / svátek  dolní statický (docházející velikosti), nahoře konec akce —
 *       dokud je daleko, věta s konkrétním dnem; pod prahem teprve ubíhající čas
 * O tom, který režim platí, rozhoduje klíč ze sdíleného NEBE_SHIP.state() — ne vlastní
 * počítání hodin. Svátky, Velikonoce a vánoční okna tak zná lišta i PDP stejně.
 *
 * Pozor na dělbu práce: jestli se lišta vůbec MÁ ukázat, rozhoduje synchronní inline skript
 * přímo v sekci (hned za lištou). Kdyby to řešil až tenhle deferovaný soubor, poskočil by
 * při každém načtení celý web. Sem patří jen to, co smí přijít o chvíli později.
 *
 * Načítá se s `defer` až za nebe-ship.js (snippet nebe-ship-i18n ho vloží dřív), takže
 * window.NEBE_SHIP je tu vždycky připravené.
 */
(function () {
  "use strict";

  // Hodnota = timestamp zavření. Klíč nese otisk znění lišty (atribut data-promo-key, počítá
  // ho sekce), takže zavřením jedné kampaně si zákazník nezavře i tu příští — musí sedět
  // s inline skriptem v nebe-ship-bar.liquid, který podle téhož klíče lištu odstraňuje.
  function keyFor(bar) {
    return "nebe:shipbar:dismissed:" + ((bar && bar.dataset.promoKey) || "0");
  }

  // Sticky hlavička, vyhledávání i slideshow počítají s --announcement-height. Sekce ji
  // emituje odhadem z Liquidu (aby se nic nehýbalo hned po načtení), tady ji srovnáme na
  // skutečnou výšku.
  //
  // Lišt je nad sebou víc (expediční slib, kreditní kampaň) a každá se ukazuje podle jiné
  // podmínky, takže se výška NIKDY nesmí brát z jedné z nich — vždycky je to součet všech,
  // které zrovna nejsou schované. Skrytá lišta má offsetHeight 0, ale hidden filtrujeme
  // i tak, ať se nespoléháme na pořadí načtení CSS.
  //
  // V selektoru je vedle [data-nebe-bar] i vlastní [data-ship-bar] jako pojistka pro případ,
  // že by sekce společný atribut nestihla dostat. querySelectorAll uzly nezdvojuje, takže
  // lišta s oběma atributy se do součtu započítá jednou.
  function measureBars() {
    var bars = document.querySelectorAll("[data-nebe-bar], [data-ship-bar]");
    var px = 0;
    for (var i = 0; i < bars.length; i++) if (!bars[i].hidden) px += bars[i].offsetHeight;
    document.documentElement.style.setProperty("--announcement-height", px + "px");
    return px;
  }

  // Vystaveno kvůli nebe-credit.js: druhá lišta musí počítat TÝMŽ součtem, jinak se dvě
  // plochy přetahují o jednu CSS proměnnou a hlavička poskakuje.
  if (!window.NEBE_BARS) window.NEBE_BARS = { measure: measureBars };

  // Režim lišty. „ship" = dnes se ještě odesílá (tiká spodní řádek), „after" = uzávěrka je
  // za námi, je víkend nebo svátek (tiká horní). Pozná se podle klíče ze sdíleného modulu,
  // protože jen ten zná firemní kalendář — vlastní počítání hodin by se s PDP rozešlo.
  function shipState() {
    var S = window.NEBE_SHIP;
    if (!S || !S.state) return null;
    try { return S.state(); } catch (e) { return null; }
  }
  function modeOf(st) {
    return st && st.key && st.key.indexOf("ship_today") === 0 ? "ship" : "after";
  }

  function init(bar) {
    if (bar.dataset.shipBarReady) return; // editor motivu umí sekci vyrenderovat vícekrát
    bar.dataset.shipBarReady = "1";

    measureBars();

    dropExpiredPromo(bar);

    var rowDay = bar.querySelector('[data-promo-row="day"]');
    var rowFar = bar.querySelector('[data-promo-row="far"]');
    var rowAfter = bar.querySelector('[data-promo-row="after"]');
    var promoRows = [rowDay, rowFar, rowAfter];
    // Odpočet konce akce patří ke znění „blíží se konec". Když merchant další znění nevyplnil,
    // zbyl jediný řádek a odpočet se navěsí na něj — jinak by lišta o kampani mlčela.
    var cdRow = rowAfter || rowDay;
    var promoCd = cdRow ? initCountdown(bar, cdRow) : null;

    // Odkdy se vůbec odpočítává. Nad prahem drží horní řádek větu s konkrétním dnem:
    // „končí za 6 dní 9 h" urgenci nevytvoří, jen zabere řádek.
    var fromH = parseFloat(bar.dataset.promoCdFromH);
    if (isNaN(fromH) || fromH < 0) fromH = CD_FROM_H_DEFAULT;
    var fromMs = fromH * 3600000;

    /* Který z promo řádků je na řadě. Přes den vždycky denní; po uzávěrce rozhoduje,
     * jak daleko je konec akce. Bez známého termínu se odpočet stejně nespustí, takže
     * má přednost statická věta — ta nemůže lhát o čísle, které nikdo nepočítá.
     */
    function visiblePromo(mode) {
      if (mode === "ship") return rowDay || rowFar || rowAfter;
      if (rowFar) {
        var ms = promoCd && promoCd.left ? promoCd.left() : null;
        if (ms == null || ms > fromMs) return rowFar;
      }
      return rowAfter || rowFar || rowDay;
    }

    var note = bar.querySelector("[data-ship-bar-note]");
    var noteCd = note ? initNote(bar, note) : null;

    // Jediný přepínač režimu pro oba řádky. Kdyby si každý řádek hlídal čas sám, překlopily
    // by se ve 14:00 o snímek jinak a lišta by na okamžik tikala dvakrát nebo vůbec.
    var lastMode = null, lastVis = null;
    function applyMode() {
      var st = shipState();
      var mode = modeOf(st);
      var changed = mode !== lastMode;
      lastMode = mode;

      // Viditelný je vždycky právě jeden promo řádek. Když je jediný, zůstane viditelný
      // pořád — přepínat není mezi čím.
      // Poslední den akce patří horní řádek odpočtu konce celý den, ne až od uzávěrky.
      // Konec akce je v ten den silnější důvod než expedice, a spodní řádek se proto
      // uklidní (hodina uzávěrky bez tikání), aby dál tikal jen jeden řádek.
      var leftMs = promoCd && promoCd.left ? promoCd.left() : null;
      var lastDay = !!(rowAfter && leftMs != null && leftMs > 0 && leftMs < DAY_MS);
      var vis = lastDay ? rowAfter : visiblePromo(mode);
      // Třída zvětší horní řádek na desktopu, když zůstal v liště sám (CSS --solo).
      bar.classList.toggle("nebe-shipbar--solo", lastDay);
      var swapped = vis !== lastVis;
      lastVis = vis;
      if (vis) {
        for (var i = 0; i < promoRows.length; i++) {
          if (promoRows[i]) promoRows[i].hidden = promoRows[i] !== vis;
        }
      }
      if (promoCd && cdRow.isConnected) promoCd.setActive(cdRow === vis);
      // Věta dole se mohla překlopit na jiný počet řádků — nejen ve 14:00, ale i v 9:00,
      // kdy do ní přibude tikající čas. Proto se ptáme řádku, jestli se přestavěl, a
      // neřídíme se jen změnou režimu.
      var reshaped = noteCd ? noteCd.update(st, mode, lastDay) : false;

      // Jiný počet řádků = jiná výška lišty, a na té visí sticky hlavička pod ní.
      // Prohození promo řádku se počítá taky: ve čtvrtek o půlnoci se mění jen on, ne režim.
      if (changed || swapped || reshaped) measureBars();
    }
    applyMode();

    // Stránka může zůstat otevřená přes půlnoc, kdy promo končí — hlídá to sdílený tik.
    if (window.NEBE_SHIP && window.NEBE_SHIP.onMinute) {
      // Doběhlý termín promo řádku odběr NEUKONČUJE: lišta může žít dál kvůli expedičnímu
      // slibu a ten se pořád musí ve 14:00 překlopit. Hlídá se jen to, ať se po doběhnutí
      // nekontroluje termín pořád dokola.
      var watchEnd = !!bar.dataset.promoEnd;
      window.NEBE_SHIP.onMinute(function () {
        if (!bar.isConnected) return false;
        // Tentýž tik dělá obojí schválně: ve 14:00 se překlápí horní i dolní řádek a přes
        // dvě různá přihlášení by se mohly minout o jeden tik.
        if (watchEnd && dropExpiredPromo(bar) === false) watchEnd = false;
        if (!bar.isConnected) return false;
        applyMode();
      });
    }

    var close = bar.querySelector("[data-ship-bar-close]");
    if (close) {
      close.addEventListener("click", function () {
        try { localStorage.setItem(keyFor(bar), String(Date.now())); } catch (e) {}
        bar.remove();
        measureBars(); // ne nula: kreditní lišta pod ní může zůstat viset dál
      });
    }

    // Bez podmínky na bar.isConnected schválně: po zavření křížkem by při otočení telefonu
    // už výšku nikdo nepřepočítal a zbylé liště by seděla hlavička na hlavě.
    window.addEventListener("resize", measureBars, { passive: true });

    // Značkové písmo dorazí až po prvním vykreslení a věta se v něm láme jinak než
    // v náhradním. Naměřeno: dvouřádková lišta vyjde v záložním písmu o celý řádek vyšší,
    // a ta chybná hodnota by v --announcement-height zůstala až do prvního otočení telefonu.
    try {
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measureBars);
    } catch (e) {}
  }

  // Promo řádek může mít vlastní konec platnosti (věta „v pondělí zdražujeme" v pondělí lže).
  // Liquid ho po termínu nevykreslí, jenže HTML chodí z full-page cache klidně hodiny potom,
  // takže poslední slovo má prohlížeč. Měří se týmž časem jako expediční slib, ne Date() —
  // rozhoduje pražský nástěnný čas, ne hodiny na zákazníkově notebooku.
  function dropExpiredPromo(bar) {
    var S = window.NEBE_SHIP;
    var raw = bar.dataset.promoEnd;
    if (!raw || !S || !S.parseWall || !S.minutesUntil) return true;
    var target = S.parseWall(raw);
    if (!target) return true;
    var mins = S.minutesUntil(target);
    if (mins == null || mins > 0) return true; // ještě platí, zkusíme to zas za minutu

    // querySelectorAll: znění před uzávěrkou, po ní a pro vzdálený konec akce jsou tři
    // samostatné odstavce a končí všechny naráz — je to tatáž kampaň, jen tři věty.
    var promos = bar.querySelectorAll(".nebe-shipbar__promo");
    for (var i = 0; i < promos.length; i++) promos[i].remove();
    // Rezervovaná výška popisovala dva řádky. Bez promo řádku není co srovnávat a pruh by
    // zbytečně držel místo pro větu, která už neexistuje.
    bar.classList.remove("nebe-shipbar--reserve");
    // Bez promo řádku a bez expedičního slibu by zbyl prázdný barevný pruh s křížkem.
    // Merchant si navíc může přát, aby s koncem akce zmizela lišta celá (hide_bar_after_promo).
    if (bar.dataset.hideWithPromo === "1" || !bar.querySelector("[data-ship-bar-note]")) bar.remove();
    measureBars();
    return false; // hotovo, odhlásit z tiku
  }

  // ---- odpočet v promo řádku --------------------------------------------------------------
  // Merchant napíše do promo textu %{t} a sekce na to místo vloží prázdný <span>. Tenhle blok
  // do něj sype zbývající čas — v posledních 24 hodinách po setinách vteřiny, aby byl termín
  // vidět jako ubíhající čas, ne jako datum.
  //
  // Tři pravidla, na kterých to celé stojí:
  //   1. Píše se JEN do slotu, přes textContent. Promo řádek obsahuje SVG tah podtržení
  //      z highlight-text; přepisovat kvůli číslu celý řádek by znamenalo překreslovat ten tah
  //      třicetkrát za vteřinu.
  //   2. Šířka slotu je rezervovaná v CSS podle režimu (atribut data-cd-mode), takže se při
  //      tikání nehýbe zalomení věty.
  //   3. Smyčka běží jen tehdy, když má komu tikat: ne ve skrytém tabu, ne po odscrollování
  //      lišty z obrazovky, a na slabém zařízení se sama zahodí ve prospěch tikotu po vteřinách.

  var NB = " ";
  var DAY_MS = 86400000;

  function czWord(n, one, few, many) {
    return n === 1 ? one : (n >= 2 && n <= 4 ? few : many);
  }
  function pad2(n) { return (n < 10 ? "0" : "") + n; }

  // Ladicí přebití termínu, stejná konvence jako ?ship= v nebe-ship.js a ?d=mobile v nebe-pdp.js:
  // ?promoend=2026-08-31T00:00. Bez něj se všechny čtyři režimy dají prohlédnout jen čekáním.
  function promoEndOverride() {
    try {
      var m = new RegExp("[?&]promoend=([^&]+)").exec(window.location.search);
      return m ? decodeURIComponent(m[1]) : "";
    } catch (e) { return ""; }
  }

  /* Zbývající čas do podoby, jaká jde do lišty. Zkratky jednotek schválně: verzálkový řádek
   * s prostrkáním je na mobilu tak akorát široký a „1 h 30 min" ušetří proti „1 hodinu a
   * 30 minut" skoro dvacet znaků. Vteřiny a minuty jsou dvoumístné, jakmile mají před sebou
   * vyšší jednotku — jinak by se šířka měnila při každém přeskoku přes desítku.
   *   coarse = true → bez setin (slabé zařízení nebo vypnuté animace)
   *   minuteOnly = true → bez vteřin vůbec. Nad prahem „Vteřiny v odpočtu poslední" nemá
   *     smysl kreslit vteřiny, které se stejně přepisují jen jednou za minutu — visela by
   *     tam zamrzlá číslice a to je horší než čas bez vteřin.
   * Vrací i jméno režimu, podle kterého si CSS rezervuje šířku slotu.
   */
  function formatLeft(ms, coarse, minuteOnly) {
    if (ms < 0) ms = 0;
    var d = Math.floor(ms / DAY_MS);
    var h = Math.floor(ms / 3600000) % 24;
    var m = Math.floor(ms / 60000) % 60;
    var sec = Math.floor(ms / 1000) % 60;
    var cs = Math.floor(ms / 10) % 100;
    // I samotné vteřiny jsou dvoumístné: bez toho by se text při přechodu přes desítku
    // zkrátil o znak a celý vycentrovaný řádek by poskočil.
    var s = coarse ? pad2(sec) + NB + "s" : pad2(sec) + "," + pad2(cs) + NB + "s";

    // Nad den nemá cenu tikat po setinách: číslo, které se hýbe, je stejně jen to poslední,
    // a „2 dny 5 h 12 min 20,20 s" je řádek, který se na mobilu nevejde nikam.
    //
    // Vteřiny ale nad den jdou taky (bez setin): „1 den 6 h 33 min 05 s" ukazuje, že čas
    // opravdu ubíhá, i když do konce zbývá víc než den. Vypíná je stejný minuteOnly jako
    // níž, takže přes den, kdy tiká spodní řádek, zůstane horní klidný.
    if (d > 0) {
      var dh = d + NB + czWord(d, "den", "dny", "dní") + " " + h + NB + "h ";
      if (minuteOnly) return { mode: "dhm", text: dh + m + NB + "min" };
      return { mode: "dhms", text: dh + pad2(m) + NB + "min " + pad2(sec) + NB + "s" };
    }
    if (minuteOnly) {
      if (h > 0) return { mode: "hm", text: h + NB + "h " + pad2(m) + NB + "min" };
      return { mode: "m", text: m + NB + "min" };
    }
    if (h > 0) return { mode: "hms", text: h + NB + "h " + pad2(m) + NB + "min " + (coarse ? pad2(sec) + NB + "s" : pad2(sec) + "," + pad2(cs) + NB + "s") };
    if (m > 0) return { mode: "ms", text: m + NB + "min " + (coarse ? pad2(sec) + NB + "s" : pad2(sec) + "," + pad2(cs) + NB + "s") };
    return { mode: "s", text: s };
  }

  /* Znění pro čtečku obrazovky. Tikající číslo se odposlechnout nedá, takže vedle viditelného
   * řádku stojí druhý, schovaný, s hrubým časem a plnými slovy — a hlavně ve tvaru, který sedí
   * za předložku „za" (za 1 hodinu, za 2 hodiny, za 5 hodin).
   * Přepisuje se jen jednou za minutu; aria-live tu není schválně, ta by mluvila pořád.
   */
  function coarseWords(ms) {
    if (ms < 0) ms = 0;
    var d = Math.floor(ms / DAY_MS);
    var h = Math.floor(ms / 3600000) % 24;
    var m = Math.floor(ms / 60000) % 60;
    var mm = m + NB + czWord(m, "minutu", "minuty", "minut");
    var hh = h + NB + czWord(h, "hodinu", "hodiny", "hodin");
    if (d > 0) return d + NB + czWord(d, "den", "dny", "dní") + ", " + hh + " a " + mm;
    if (h > 0) return hh + " a " + mm;
    if (m > 0) return mm;
    return "necelou minutu";
  }

  // Emoji nesou v promo textu význam pro oko („🔥 Poslední kusy"), ale čtečka je čte jako
  // název znaku. Pro odposlech si proto stavíme holou variantu. Regexy stejné jako
  // stripEmoji v nebe-credit.js — ta je zavřená ve vlastní IIFE a lišta na ni nedosáhne.
  function stripEmoji(str) {
    return String(str || "")
      .replace(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g, "")
      .replace(/[←-⇿⌀-⏿☀-➿⬀-⯿️⃣〰〽]/g, "")
      .replace(/\s{2,}/g, " ")
      .trim();
  }

  var CD_UNDER_H_DEFAULT = 48;
  var CD_FROM_H_DEFAULT = 96;

  function initCountdown(bar, root) {
    var slot = root.querySelector("[data-promo-cd]");
    if (!slot) return null; // promo text bez %{t} — není co počítat

    var S = window.NEBE_SHIP;
    var raw = promoEndOverride() || bar.dataset.promoEnd;
    var wall = S && S.parseWall ? S.parseWall(raw) : null;
    var target = wall && S.epochOf ? S.epochOf(wall) : null;
    // Bez platného termínu se nespouští nic. Sekce takový případ nevykreslí (viz podmínka
    // has_countdown v nebe-ship-bar.liquid), tohle je pojistka pro cache se starým HTML.
    if (!target) return null;

    // Práh pro vteřiny, v hodinách z nastavení sekce. Nad ním se kreslí jen dny a minuty.
    var underH = parseFloat(bar.dataset.promoCdUnderH);
    if (isNaN(underH) || underH < 0) underH = CD_UNDER_H_DEFAULT;
    var underMs = underH * 3600000;

    var sr = root.querySelector("[data-promo-sr]");
    var tpl = root.dataset.promoTpl || bar.dataset.promoTpl || "";
    var lastText = "", lastMode = "", lastSr = "";
    var stopFrame = null;
    // Tiká tenhle řádek? Přes den ne — tehdy patří pozornost odpočtu do uzávěrky dole.
    var active = false;

    function left() { return target - Date.now(); }

    function paint(coarse) {
      var ms = left();
      if (ms <= 0) { finish(); return false; }

      // Neaktivní řádek se pořád musí vykreslit pravdivě, jen hrubě: kdyby se do slotu
      // nenapsalo nic, visela by v liště useknutá věta „Doprava zdarma končí za .".
      var out = formatLeft(ms, coarse, !active || ms >= underMs);
      if (out.mode !== lastMode) {
        // Atribut řídí rezervovanou šířku slotu v CSS. Mění se párkrát za celou kampaň,
        // takže je to jediný okamžik, kdy se šířka řádku vůbec smí hnout.
        slot.setAttribute("data-cd-mode", out.mode);
        lastMode = out.mode;
        // Jiná rezervovaná šířka slotu umí posunout zalomení celé věty, a tím i výšku lišty.
        measureBars();
      }
      if (out.text !== lastText) {
        // Číslice sázíme do pevné mřížky (viz paintDigits v nebe-ship.js) — značkový font
        // nemá tabulární číslice, takže by se šířka řádku měnila s každou setinou.
        if (S.paintDigits) S.paintDigits(slot, out.text); else slot.textContent = out.text;
        lastText = out.text;
      }
      return true;
    }

    // Vteřiny do textu pro čtečku nepatří, takže stačí minutový tik sdílený s expedičním slibem.
    function paintSr() {
      if (!sr || !tpl) return;
      var txt = stripEmoji(tpl).split("%{t}").join(coarseWords(left()));
      if (txt !== lastSr) { sr.textContent = txt; lastSr = txt; }
    }

    function finish() {
      if (stopFrame) { stopFrame(); stopFrame = null; }
      // Skrytí po doběhnutí termínu řeší jedno jediné místo — tohle je jen přesnější spoušť
      // než minutový tik: promo řádek zmizí v ten okamžik, kdy odpočet dojede na nulu.
      dropExpiredPromo(bar);
    }

    // Jemná smyčka se spouští jen tehdy, když má co ukazovat: řádek je na řadě, zbývá méně
    // než den a zároveň méně, než kolik si merchant nastavil. Zapne se sama, jakmile to
    // začne platit — proto se volá i z minutového tiku, ne jen jednou na startu.
    function run() {
      if (!slot.isConnected) return;
      var ms = left();
      if (ms <= 0) { finish(); return; }
      // Nad den se dřív jemná smyčka nespouštěla (bez vteřin nebylo co kreslit). Teď se
      // vteřiny ukazují i tam, takže o smyčce rozhoduje jen aktivita řádku a práh z nastavení.
      if (!active || ms >= underMs) {
        if (stopFrame) { stopFrame(); stopFrame = null; }
        return;
      }
      if (stopFrame || !S.onFrame) return;
      stopFrame = S.onFrame(paint, { watch: bar });
    }

    paint(S.isCoarse ? S.isCoarse() : false);
    paintSr();
    run();

    if (S.onMinute) {
      S.onMinute(function () {
        if (!slot.isConnected) return false;
        paintSr();
        // Minutový tik je zároveň jediné, co kreslí odpočet mimo jemnou smyčku.
        if (!stopFrame) { if (!paint(true)) return false; }
        run();
      });
    }

    return {
      // Zbývající čas do konce akce. Vystaveno kvůli výběru promo řádku: měří se tímtéž
      // termínem a týmž časem jako odpočet, jinak by se řádek přepnul jindy, než začne tikat.
      left: left,
      setActive: function (on) {
        on = !!on;
        if (on === active || !slot.isConnected) return;
        active = on;
        // Režim se s aktivitou mění (s vteřinami / bez nich), takže se musí překreslit hned,
        // ne až za minutu — jinak by po 14:00 chvíli visel čas bez vteřin.
        paint(S.isCoarse ? S.isCoarse() : false);
        run();
      }
    };
  }

  /* ---- spodní řádek: expediční slib a odpočet do uzávěrky --------------------------------
   * Dvě podoby, mezi kterými se přepíná ve 14:00:
   *   před uzávěrkou  věta ze sdíleného modulu s tikajícím slotem („objednej během
   *                   4 h 59 min 53 s a …")
   *   po uzávěrce     statická věta z nastavení sekce (docházející velikosti); tehdy tiká
   *                   horní řádek a tady by druhý běžící odpočet jen tříštil pozornost
   *
   * ŽÁDNÉ ZNĚNÍ TU NENÍ. Věty před uzávěrkou přicházejí z locales (klíč ship_bar_today, nebo
   * ship_today_* jako záloha), věta po uzávěrce z nastavení sekce. Tenhle soubor rozhoduje
   * jen o tom, KDY se která ukáže a kam se posadí slot s časem — o znění ne, a o tom, která
   * věta před uzávěrkou platí (pátek, vánoční okno), rozhoduje engine.
   *
   * Věta se skládá JEDNOU za režim, ne při každé vteřině: vteřiny se sázejí do vlastního
   * <span> přes paintDigits, protože Jost nemá tabulární číslice a bez mřížky by se řádek
   * při každém překreslení hýbal.
   *
   * Vrací z update() true, když se věta přestavěla — volající si podle toho přeměří výšku.
   */
  function initNote(bar, note) {
    var S = window.NEBE_SHIP;
    if (!S) { note.hidden = true; return null; }

    // Značka, na jejímž místě vznikne slot odpočtu. Prochází jen přes locale šablonu, takže
    // stačí, aby ji nikdo nenapsal do překladu — proto ty zavináče.
    var MARK = "@@nebecd@@";
    var SLOT_HTML = '<span class="nebe-shipbar__cd nebe-shipbar__cd--ship" data-ship-cd></span>';

    var pronoun = bar.dataset.pronoun;
    var afterText = (note.dataset.tAfterCutoff || "").trim();
    var slot = null, srEl = null;
    var shape = null;          // otisk právě postavené kostry věty
    var cdMode = "", cdText = "";
    var ticking = false;
    var cutoffAt = null, cutoffHour = null;
    var stopFrame = null;

    function stopTick() {
      if (stopFrame) { stopFrame(); stopFrame = null; }
    }

    function setShape(key, html, isHtml) {
      if (shape === key) return false;
      shape = key;
      slot = null;
      srEl = null;
      cdMode = "";
      cdText = "";
      if (isHtml) note.innerHTML = html; else note.textContent = html;
      slot = note.querySelector("[data-ship-cd]");
      srEl = note.querySelector("[data-ship-sr]");
      return true;
    }

    // Kolik vteřin zbývá do uzávěrky. Počítá se z absolutního okamžiku, ne z minut ve stavu:
    // pražské „nástěnné" části vteřiny neznají a stav se přepočítává jen jednou za minutu.
    function secsLeft() {
      return cutoffAt == null ? null : (cutoffAt - Date.now()) / 1000;
    }

    function paintSlot() {
      if (!slot || cutoffAt == null) return false;
      var secs = Math.floor(secsLeft());
      if (secs < 0) secs = 0;
      // Lehká kopie stavu: byText() z ní čte jen zbývající minuty a hodinu uzávěrky, a takhle
      // je má vždycky čerstvé, i když se stav naposledy počítal před padesáti vteřinami.
      var txt = S.byText({ minsLeft: Math.ceil(secs / 60), cutoff: cutoffHour }, false, secs);
      // Locale klíč smí nést &nbsp; (věty se jinde sázejí přes innerHTML), ale tady jde text
      // po znacích do textContent, kde by se entita přečetla doslova.
      txt = String(txt).split("&nbsp;").join(" ");
      if (txt !== cdText) {
        if (S.paintDigits) S.paintDigits(slot, txt); else slot.textContent = txt;
        cdText = txt;
      }
      return secs > 0;
    }

    /* update(st, mode) — zavolá se jednou za minutu (a při každé změně režimu) z applyMode.
     * Tady se rozhoduje VŠECHNO, co se za minutu změnit může; jemná smyčka pak už jen sype
     * číslice do slotu.
     */
    function update(st, mode, calm) {
      // Poslední den akce: celou lištu drží odpočet konce nahoře a spodní řádek mizí úplně
      // (rozhodnutí 24. 9. 2026: dvě sdělení naráz se v ten den tříštila).
      if (calm) {
        stopTick();
        cutoffAt = null;
        var wasShown = shape !== "calm";
        shape = "calm";
        note.hidden = true;
        return wasShown;
      }
      if (mode === "ship" && st && st.minsLeft != null) {
        cutoffAt = st.cutoffAt != null ? st.cutoffAt : null;
        cutoffHour = st.cutoff;

        var tpl = "";
        // Bez absolutního okamžiku uzávěrky (starší nebe-ship.js z cache) se vteřiny
        // spočítat nedají. Radši hodina uzávěrky bez odpočtu než prázdné místo ve větě.
        // calm = poslední den akce, kdy nahoře tiká její konec: tady pak stojí jen hodina
        // uzávěrky („do 14:00"), aby netikaly dva řádky naráz.
        var withSlot = cutoffAt != null && !calm;
        try {
          tpl = withSlot
            ? S.text({ surface: "bar", pronoun: pronoun, state: st, bySlot: MARK })
            : S.text({ surface: "bar", pronoun: pronoun, state: st, noCountdown: true });
        } catch (e) { tpl = ""; }
        // Prázdno = slib je vypnutý vyprázdněným locale klíčem (tak se vypínal za expediční
        // krize). Řádek zmizí, lišta zůstane kvůli promo sdělení nad ním.
        if (!tpl) {
          stopTick();
          note.hidden = true;
          var wasOn = shape !== "off";
          shape = "off";
          return wasOn;
        }

        // Stabilní znění pro čtečku: tikající číslo se odposlechnout nedá, a aria-live tu
        // být nesmí — mluvila by při každém snímku.
        var spoken = "";
        try {
          spoken = S.text({ surface: "bar", pronoun: pronoun, state: st, noCountdown: true });
        } catch (e) {}

        var html = tpl.split(MARK).join(SLOT_HTML);
        if (spoken) {
          html = '<span aria-hidden="true">' + html + '</span>' +
                 '<span class="visually-hidden" data-ship-sr></span>';
        }
        var reshaped = setShape("ship:" + tpl + "|" + spoken, html, true);
        if (srEl) srEl.textContent = spoken;
        note.hidden = false;

        // Tiká se jen tehdy, když sdílený modul opravdu vrátil ubíhající čas. Porovnání
        // s tvarem „do 14:00" je záměr: práh, odkdy se tiká, zná nebe-ship.js a nemá cenu
        // ho tu mít podruhé a rozejít se s ním.
        var secs = Math.floor(secsLeft());
        var live = paintSlot();
        var fixed = S.byText({ minsLeft: st.minsLeft, cutoff: st.cutoff }, true);
        ticking = live && slot != null && cdText !== String(fixed).split("&nbsp;").join(" ");

        // Šířku slotu rezervuje CSS podle režimu. V okně 9:00 až 14:00 je hodina vždycky
        // jednociferná, takže nejdelší tvar je „4 h 59 min 59 s" a nemusí se rezervovat na
        // dvojciferné hodiny. Režim se mění jen na hranici minuty, proto se počítá tady.
        var m = !ticking ? "fixed" : secs >= 3600 ? "hms" : secs >= 60 ? "ms" : "s";
        if (slot && m !== cdMode) {
          slot.setAttribute("data-cd-mode", m);
          cdMode = m;
          reshaped = true; // jiná rezervovaná šířka = věta se může zalomit jinak
        }

        if (ticking && S.onFrame) {
          if (!stopFrame) stopFrame = S.onFrame(function () { return paintSlot(); }, { watch: bar });
        } else stopTick();
        return reshaped;
      }

      // Po uzávěrce, o víkendu a ve svátek: statická věta z nastavení sekce, žádný odpočet.
      stopTick();
      cutoffAt = null;
      if (afterText) {
        // textContent, ne innerHTML: text píše merchant v nastavení sekce a nesmí se z něj
        // dát vyrobit značka.
        var changedAfter = setShape("after:" + afterText, afterText, false);
        note.hidden = false;
        return changedAfter;
      }
      // Bez vlastního znění zůstává původní chování: „Objednávky odesíláme zítra".
      var fallback = "";
      try { fallback = S.text({ surface: "bar", pronoun: pronoun, state: st }); } catch (e) {}
      var changedPlain = setShape("plain:" + fallback, fallback, true);
      note.hidden = !fallback;
      return changedPlain;
    }

    return { update: update };
  }

  /* ---- odpočet v textech slideshow na homepage -------------------------------------------
   * Merchant napíše do podnadpisu (nebo nadpisu či textu) slidu %{t} a tady se na to místo
   * posadí tikající čas do konce akce. Termín je TENTÝŽ, který řídí promo řádek lišty
   * (data-promo-end, podle trhu), takže banner a lišta nemůžou ukazovat dva různé konce.
   *
   * Slideshow je sekce jádra, do které se nesahá (ZASAHY-DO-JADRA-SABLONY.md): text nese
   * nastavení bloku a my ho jen dočteme v prohlížeči. Proto taky platí stejná kázeň jako
   * u lišty: bez platného termínu, nebo po jeho uplynutí, se celý řádek s %{t} SCHOVÁ.
   * Useknutá věta „Už jen %{t}" na hlavní stránce je horší než chybějící řádek.
   *
   * Tiká po vteřinách bez setin: banner je velký a setiny by v něm jen blikaly. */
  function initHeroCountdown(bar) {
    var MARK = "%{t}";
    var hosts = document.querySelectorAll(".slideshow__subheading, .slideshow__heading, .slideshow__text");
    var found = [];
    for (var i = 0; i < hosts.length; i++) {
      var el = hosts[i];
      if (el.dataset.nebeHeroCd || el.textContent.indexOf(MARK) === -1) continue;
      el.dataset.nebeHeroCd = "1";
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
      var nodes = [], n;
      while ((n = walker.nextNode())) if (n.nodeValue.indexOf(MARK) !== -1) nodes.push(n);
      for (var j = 0; j < nodes.length; j++) {
        var tn = nodes[j], at = tn.nodeValue.indexOf(MARK);
        var slot = document.createElement("span");
        slot.className = "nebe-herocd";
        var rest = tn.splitText(at);
        rest.nodeValue = rest.nodeValue.slice(MARK.length);
        tn.parentNode.insertBefore(slot, rest);
        found.push({ host: el, slot: slot });
      }
      if (!nodes.length) found.push({ host: el, slot: null }); // %{t} rozdělené značkou
    }
    if (!found.length) return;

    // Schovává se nejmenší celek, který odpočet nese. Když je věta s %{t} jen první znění
    // časově přepínaného textu (nebe-timed-text), zmizí jen ona a znění po termínu zůstane.
    function hideAll() {
      found.forEach(function (f) {
        var own = f.slot && f.slot.closest("[data-nebe-until]");
        (own || f.host).style.display = "none";
      });
    }

    var S = window.NEBE_SHIP;
    var raw = promoEndOverride() || (bar && bar.dataset.promoEnd) || "";
    var wall = S && S.parseWall ? S.parseWall(raw) : null;
    var target = wall && S.epochOf ? S.epochOf(wall) : null;
    if (!target || found.some(function (f) { return !f.slot; })) { hideAll(); return; }

    var lastText = "";
    function paint() {
      var ms = target - Date.now();
      if (ms <= 0) { hideAll(); return false; }
      var out = formatLeft(ms, true, false);
      if (out.text !== lastText) {
        found.forEach(function (f) {
          if (S.paintDigits) S.paintDigits(f.slot, out.text); else f.slot.textContent = out.text;
        });
        lastText = out.text;
      }
      return true;
    }
    if (paint() === false) return;
    // Hlídá se celá sekce, ne první výskyt: slideshow má text dvakrát (desktop a mobil)
    // a jedna z kopií je vždycky skrytá, takže by se podle ní nekreslilo nikdy.
    var watchEl = found[0].host.closest(".shopify-section") || found[0].host;
    if (S.onFrame) S.onFrame(paint, { watch: watchEl });
    else setInterval(paint, 250);
  }

  /* ---- sliby s koncem platnosti ------------------------------------------------------------
   * Liquid po termínu slib nevykreslí, jenže storefront HTML chodí z full-page cache klidně
   * hodiny potom. Poslední slovo má proto prohlížeč, měřeno pražským časem ze sdíleného modulu:
   *   [data-nebe-until="RRRR-MM-DDTHH:MM"]  po termínu se smaže (odznak, věta s dopravou zdarma)
   *   [data-nebe-after="RRRR-MM-DDTHH:MM"]  po termínu se odkryje (znění, které platí potom)
   * Prohlíží se celý dokument, takže to chytí i prvky, které JS postaví později (mobilní
   * popisek galerie na PDP), nejpozději s dalším minutovým tikem. */
  function sweepUntil() {
    var S = window.NEBE_SHIP;
    if (!S || !S.parseWall || !S.epochOf) return;
    var now = Date.now();
    function due(el, attr) {
      var w = S.parseWall(el.getAttribute(attr));
      var t = w ? S.epochOf(w) : null;
      return t != null && now >= t;
    }
    var gone = document.querySelectorAll("[data-nebe-until]");
    for (var i = 0; i < gone.length; i++) if (due(gone[i], "data-nebe-until")) gone[i].remove();
    var shown = document.querySelectorAll("[data-nebe-after][hidden]");
    for (var j = 0; j < shown.length; j++) if (due(shown[j], "data-nebe-after")) shown[j].hidden = false;
  }
  var sweepBound = false;

  /* ---- tikající odpočty mimo lištu (sidecart) -------------------------------------------
   * [data-nebe-cd="RRRR-MM-DDTHH:MM"] s potomkem [data-nebe-cd-t]: do slotu se sype zbývající
   * čas po vteřinách. Drawer se překresluje přes Section Rendering API, takže se uzly hledají
   * při každém tiku znovu a nic se neváže na konkrétní element. Čtyřikrát za vteřinu stačí:
   * setiny tu nejsou a hledání pár uzlů nic nestojí. Po termínu uzel zmizí. */
  var inlineCdTimer = null;
  function paintInlineCountdowns() {
    var S = window.NEBE_SHIP;
    if (!S || !S.parseWall || !S.epochOf) return;
    var els = document.querySelectorAll("[data-nebe-cd]");
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var w = S.parseWall(el.getAttribute("data-nebe-cd"));
      var t = w ? S.epochOf(w) : null;
      if (t == null) { el.remove(); continue; }
      var ms = t - Date.now();
      if (ms <= 0) { el.remove(); continue; }
      var slot = el.querySelector("[data-nebe-cd-t]");
      if (!slot) continue;
      var txt = formatLeft(ms, true, false).text;
      if (slot.getAttribute("data-last") === txt) continue;
      slot.setAttribute("data-last", txt);
      if (S.paintDigits) S.paintDigits(slot, txt); else slot.textContent = txt;
    }
  }
  function initInlineCountdowns() {
    paintInlineCountdowns();
    if (!inlineCdTimer) inlineCdTimer = setInterval(function () {
      if (!document.hidden) paintInlineCountdowns();
    }, 250);
  }

  function boot() {
    var bar = document.querySelector("[data-ship-bar]");
    if (bar) init(bar);
    initHeroCountdown(bar);
    initInlineCountdowns();
    sweepUntil();
    if (!sweepBound && window.NEBE_SHIP && window.NEBE_SHIP.onMinute) {
      sweepBound = true;
      window.NEBE_SHIP.onMinute(function () { sweepUntil(); });
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  // editor motivu: po přerenderování sekce se musí navázat znovu
  document.addEventListener("shopify:section:load", boot);
})();
